$(document).ready(function () {
  // Function to change steps
  function changeStep(hideStep, showStep) {
    $(hideStep).hide(); // Always hide the step to be hidden

    $(showStep).show();
    $("html, body").animate(
      {
        scrollTop: 0, // Scroll to the top of the page when showing a new step
      },
      800
    );
  }

  if ($(".main-steps-div").hasClass("new-hidding")) {
    $("#last-number").hide();
    $(".scnd-last-num").addClass("hide-img");
    $(".steps-col").addClass("steps-col-new");
  }

  var horseName = "";
    if (
    window.location.href.includes("form_type=customer#newsletter-form") ||
    window.location.href.includes("form_type=customer")
  ) {
    window.location.href = "/cart";
  }

  // Step 1 to Step 2
  $("#mak_one-btn").on("click", function () {
    horseName = $('input[name="properties[Horses Name]"]').val().trim();
    if (horseName === "") {
      alert("Please enter a horse name.");
      return;
    }
    changeStep("#step-1", "#step-2");
    $(".number-2").addClass("active");
    $(".number-1").removeClass("active");
  });

  // Step 2 to Step 1
  $("#step-2-back").on("click", function () {
    changeStep("#step-2", "#step-1");
    $(".number-1").addClass("active");
    $(".number-2").removeClass("active");
  });

  // Step 2 to Step 3 or Step 4 based on visibility
  $("#mak_two-btn").on("click", function () {
    var firstName = $('input[name="contact[first_name]"]').val().trim();
    var email = $('input[name="contact[email]"]').val().trim();
    var checkbox = $("#i-agree-to-the-terms-of-use-privacy-policy").is(
      ":checked"
    );

    if (firstName === "" || email === "" || !checkbox) {
      alert("Please enter your name, email address, and agree to the terms.");
      return;
    }

    // Determine whether to show Step 3 or Step 4
    if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-2", "#step-4");
      $(".number-3").addClass("active");
      $(".number-2").removeClass("active");
      $("#replace-text1").text("What Colour Is " + horseName + "?");
      $("#step-3").hide(); // Hide Step 3 if it's marked for hiding
    } else {
      changeStep("#step-2", "#step-3");
      $(".number-3").addClass("active");
      $(".number-2").removeClass("active");
      $("#replace-text").text("How big is " + horseName + "?");
    }
  });

  // Step 4 to Step 2 or Step 3 based on visibility
  $("#step-4-back").on("click", function () {
    if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-4", "#step-2");
      $(".number-2").addClass("active");
      $(".number-4").removeClass("active");
      $(".number-3").removeClass("active");
      $("#step-3").hide();
    } else {
      changeStep("#step-4", "#step-3");
      $(".number-3").addClass("active");
      $(".number-4").removeClass("active");
      $("#replace-text").text("How big is " + horseName + "?");
    }
  });

  // Step 3 to Step 2
  $("#step-3-back").on("click", function () {
    changeStep("#step-3", "#step-2");
    $(".number-2").addClass("active");
    $(".number-3").removeClass("active");
  });

  // Step 3 to Step 4 or Step 5 based on visibility
  $("#mak_3-btn").on("click", function () {
    if ($("#step-4").hasClass("new-hidding")) {
      changeStep("#step-3", "#step-5");
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $("#step-4").hide(); // Hide Step 4 if marked for hiding
    } else {
      changeStep("#step-3", "#step-4");
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $("#replace-text1").text("What Colour Is " + horseName + "?");
    }
  });

  // Step 5 to Step 3 or Step 5 based on visibility
  $("#step-5-back").on("click", function () {
    if ($("#step-4").hasClass("new-hidding")) {
      changeStep("#step-5", "#step-3");
      $(".number-3").addClass("active");
      $(".number-4").removeClass("active");
      $("#step-4").hide(); // Hide Step 4 if marked for hiding
    } else {
      changeStep("#step-5", "#step-4");
      $(".number-4").addClass("active");
      $(".number-5").removeClass("active");
      $("#replace-text").text("How big is " + horseName + "?");
    }
  });

  // Step 4 to Step 5
  $("#mak_4-btn").on("click", function () {
    if ($("#step-5").hasClass("new-hidding")) {
      changeStep("#step-4", "#step-6");
      $(".number-4").removeClass("active");
      $("#step-5").hide();
    } else {
      changeStep("#step-4", "#step-5");
      $(".number-5").addClass("active");
      $(".number-4").removeClass("active");
    }
  });
  $("#mak_4-btn").on("click", function () {
    if ($("#step-3").hasClass("new-hidding")) {
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
    }
  });
      $("#mak_4-btn").on("click", function () {
    if ($("#step-5").hasClass("new-hidding")) {
      $(".mak_top-steps").hide();
      $(".step-6-bar").show();
      $(".mak_steps-heading").hide();
    }
  });
 $("#step-6-back").on("click", function () {
    if ($("#step-3").hasClass("new-hidding")) {
      $(".step-6-bar").hide();
      $(".mak_steps-heading").show();
      $(".mak_top-steps").show();
    }
  });
   $("#step-6-back").on("click", function () {
    if ($("#step-5").hasClass("new-hidding")) {
      $(".step-6-bar").hide();
      $(".mak_steps-heading").show();
      $(".mak_top-steps").show();
    }
  });
   $("#step-6-back").on("click", function () {
    if ($("#step-4").hasClass("new-hidding")) {
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".step-6-bar").hide();
      $(".mak_steps-heading").show();
      $(".mak_top-steps").show();
    }
  });
  // Step 6 to Step 4 or Step 5 based on visibility
  $("#step-6-back").on("click", function () {
    if ($("#step-5").hasClass("new-hidding")) {
      changeStep("#step-6", "#step-4");

      $(".number-4").addClass("active");
      $(".number-5").removeClass("active");
      $("#step-5").hide(); // Hide Step 4 if marked for hiding
    } else {
      changeStep("#step-6", "#step-5");
      $(".number-5").addClass("active");
      $(".number-4").removeClass("active");
      $(".step-6-bar").hide();
      $(".mak_steps-heading").show();
      $(".mak_top-steps").show();
    }
  });

  // Step 5 to Step 6
  $("#mak_5-btn").on("click", function () {
    changeStep("#step-5", "#step-6");
    $(".mak_steps-heading").hide();
    $(".mak_top-steps").hide();
    $(".step-6-bar").show();
  });

  // Step 6 to Step 7
  $("#mak_6-btn").on("click", function () {
    changeStep("#step-6", "#step-7");
    $(".mak_steps-heading").hide();
    $(".step-6-bar").hide();
  });
 $("#step-6-back").on("click", function () {
    if ($("#step-4").hasClass("new-hidding")) {
      $(".mak_top-steps").show();
    }
  });

  // Step 7 to Step 6
  $("#step-7-back").on("click", function () {
    changeStep("#step-7", "#step-6");
    $(".mak_steps-heading").hide();
    $(".step-6-bar").hide();
  });

  // Proceed to checkout and add product to cart
  $("#mak-checkout").on("click", function () {
 var formData = {
  "Horses Name": $('input[name="properties[Horses Name]"]').val(),
  Name: $('input[name="contact[first_name]"]').val(),
  Email: $('input[name="contact[email]"]').val()
};

if (!$("#step-3").hasClass("new-hidding")) {
  formData.Size = $('input[name="size"]:checked').val();
}

if (!$("#step-4").hasClass("new-hidding")) {
  formData.Colour = $('input[name="colour"]:checked').val();
}

if (!$("#step-5").hasClass("new-hidding")) {
  formData.Treats = $('input[name="treats"]:checked').val();
}

// If none of the classes are present, pick all data
if (!$("#step-3").hasClass("new-hidding") && !$("#step-4").hasClass("new-hidding") && !$("#step-5").hasClass("new-hidding")) {
  formData.Size = $('input[name="size"]:checked').val();
  formData.Colour = $('input[name="colour"]:checked').val();
  formData.Treats = $('input[name="treats"]:checked').val();
}


    var inputFieldTags = document.querySelector('input[name="contact[tags]"]');
    var initialTags = inputFieldTags ? inputFieldTags.value : "";

    var tagsValue = Object.values(formData)
      .filter(
        (value, index) =>
          value !== undefined && value !== "" && index !== 1 && index !== 2
      )
      .join(", ");

    // Combine initial tags with form data tags
    tagsValue = initialTags + (initialTags ? ", " : "") + tagsValue;
    $('input[name="contact[tags]"]').val(tagsValue);

    console.log("FormData:", formData);
    console.log("Combined Tags:", tagsValue);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: $('input[name="susbscription"]:checked').val(),
        selling_plan: $('input[name="susbscription"]:checked').attr("data-sub"),
        properties: formData,
      },
      dataType: "json",
      success: function () {
        console.log("Product added to cart successfully");
        // Trigger form submission
        $("#mak-form-submit").trigger("click");
      },
      error: function (xhr, status, error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
});
